module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_shisyu-de917ba801b40a4f0a5c91776e6ef562.png";